// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 221) return "static/chunks/221-e04f9a998ab837b8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "605f11c75da2b06c" + ".js";
};